import cn from 'clsx'

import { getSanityLink } from 'shared-functions'

import { Button, Copy } from 'shared-components'

import { type Points as PointsType } from '../../../../../apps/benmax/src/types/sanity.types'

import s from './Points.module.sass'

type ExtendedPointsType = PointsType & {
    icon: string
}
function Points({ subtitle, title, copy, link, points, icon }: ExtendedPointsType) {
    const _link = link?.linkType === 'internal' || link?.linkType === 'external' ? getSanityLink(link) || null : null

    return (
        <section className={s.Points}>
            <div className={cn(s.Cont, 'container')}>
                <div className={s.Main}>
                    {subtitle && <div className="smallCaps">{subtitle}</div>}
                    {title && <h2>{title}</h2>}
                    {copy && (
                        <div className={s.Copy}>
                            <Copy copy={copy} size="small" />
                        </div>
                    )}
                    {_link && <Button url={_link?.url || ''} title={_link?.title || ''} />}
                </div>
                {points && points?.length > 0 && (
                    <div className={s.PointsGrid}>
                        {points?.map((point, index) => (
                            <div className={s.Point} key={index}>
                                {icon}
                                <h3>{point.title}</h3>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </section>
    )
}

export default Points
